import { buildVenuePath } from '../utils/venueRouting';
import React, { useContext } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import AppContext from '../contexts/AppContext';

// 允许在暂停时仍可访问的白名单（例如错误页、申诉页、健康检查等）
const ALLOWLIST_WHEN_SUSPENDED = ['/error'];

const RequireActive = ({ children }) => {
  const { suspended, venueId } = useContext(AppContext);
  const location = useLocation();

  if (suspended && !ALLOWLIST_WHEN_SUSPENDED.some(p => location.pathname.startsWith(p))) {
    return <Navigate to={buildVenuePath('/error', venueId)} replace state={{ reason: 'suspended' }} />;
  }
  return children;
};

export default RequireActive;
